import React, { useState, useEffect } from "react";
import "./index.scss";
import { useHistory } from "react-router-dom";
import {
  fetchIndividualMembership,
  generateMembershipCertificate,
  fetchFile,
} from "../../actions";
import { useDispatch, useSelector } from "react-redux";
import ier_logo from "../../assets/images/icons/ier-logo2.png";
import ReviewCard from "../../components/reviewCard";
import moment from "moment";
import download_icon from "../../assets/images/icons/download-icon.png";
import LoadingSpinner from "../../components/loadingSpiner";
import apply_icon from "../../assets/images/icons/apply-icon.png";
import { GENERATE_CERTIFICATE_LOADING_ID } from "../../store/loaders";
import FirmDetails from "./firmDetails";

const Membership = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const apiResponse = useSelector((state) => {
    const { membership, fetchFile, loader } = state;
    const { application } = membership;
    const { file } = fetchFile;
    const { isLoading } = loader[GENERATE_CERTIFICATE_LOADING_ID] || {
      isLoading: false,
    };
    return {
      application,
      file,
      isLoading,
    };
  });

  const [applicationDetails, setApplicationDetails] = useState({});
  const [hasDownloaded, setHasDownloaded] = useState(false);
  const [download, setDownload] = useState(false);

  const actionLoader = apiResponse.isLoading;

  var user = JSON.parse(localStorage.getItem("currentUser"));

  let userId;
  if(user.sub){
    userId = user.sub;
  }
  else {
    userId = user.email
  }
  useEffect(() => {
    dispatch(fetchIndividualMembership(userId));
  }, []);

  useEffect(() => {
    if (apiResponse.file?.fileText != null && !hasDownloaded && download) {
      var a = document.createElement("a");
      a.href =
        "data:image/" +
        apiResponse.file?.type +
        ";base64," +
        apiResponse.file?.fileText;
      a.download =
        apiResponse.file?.name || "File" + "." + apiResponse.file?.type || "";
      a.click();
      setHasDownloaded(true);
    }
  }, [apiResponse.file]);

  useEffect(() => {
    if (apiResponse.application) {
      setApplicationDetails(apiResponse.application);
    }
  }, [apiResponse.application]);

  const generateCertificate = (fileText) => {
    /*if (actionLoader) {
      return;
    }*/
    let url;
    console.log(fileText)
    if (fileText !== "" && fileText !== undefined) {
      url = encodeURIComponent(
        fileText.substring(fileText.indexOf("/tmp"), fileText.length)
      );
      dispatch(generateMembershipCertificate(url));
    }
    setDownload(true);
    setHasDownloaded(false);
  };
console.log(applicationDetails)
  return (
    <>
      {apiResponse.application?.memberType?.id === 1 ? (
        <div className="membership_wrapper">
          <div className="toolbar">
            <div className="toolbar-title">
              <h2>Membership</h2>
            </div>
            {apiResponse.application?.status === "Approved by ES" ? (
              <div
                className="apply-btn"
                style={{
                  padding: "10px 25px",
                  backgroundColor: actionLoader ? "#ccc" : "",
                }}
                onClick={() =>
                  generateCertificate(
                    applicationDetails.certficateFile?.fileText
                  )
                }
              >
                <img src={apply_icon} alt="file" />
                <span>Download Certificate</span>
              </div>
            ) : null}

            {apiResponse.application?.status === "Unpaid invoice(s)" && (
              <div
                className="apply-btn"
                style={{ backgroundColor: "#E01E5A" }}
                onClick={() =>
                  history.push({
                    pathname: "/applicant/payment-details",
                    state: {
                      application: applicationDetails,
                      isMembership: 3,
                      headerSection: true,
                    },
                  })
                }
              >
                <img src={apply_icon} alt="file" />
                <span>Pay for Membership</span>
              </div>
            )}
          </div>
          <div className="application-status-sub-header mt-4">
            <div className="content">
              <span
                className="title"
                style={{ textAlign: "center", fontSize: 14 }}
              >
                Membership Registration No:
              </span>
              <span className="title-content" style={{ textAlign: "center" }}>
                {apiResponse.application?.registrationNumber}
              </span>
            </div>
            <div className="content">
              <span
                className="title"
                style={{ textAlign: "center", fontSize: 14 }}
              >
                Approval Date:
              </span>
              <span className="title-content" style={{ textAlign: "center" }}>
                {moment(apiResponse.application?.approvalDate).format("MMMM Do YYYY")}
              </span>
            </div>
            <div className="content">
              <span
                className="title"
                style={{ textAlign: "center", fontSize: 14 }}
              >
                Membership Class:
              </span>
              <span className="title-content" style={{ textAlign: "center" }}>
                {apiResponse.application?.membershipClass?.name}
              </span>
            </div>
            <div className="content">
              <span
                className="title"
                style={{ textAlign: "center", fontSize: 14 }}
              >
                Membership Discipline
              </span>
              <span className="title-content" style={{ textAlign: "center" }}>
                {apiResponse.application?.discipline?.name}
              </span>
            </div>
            <div className="content">
              <span
                className="title"
                style={{ textAlign: "center", fontSize: 14 }}
              >
                Membership Application Status:
              </span>
              <span className="title-content" style={{ textAlign: "center" }}>
                {apiResponse.application?.clientStatus?.toLowerCase()}
              </span>
            </div>
          </div>
          {apiResponse.application ? (
            <div className="dashboard-review-container mt-4">
              <div className="dashboard-review-title-container">
                <div
                  style={{
                    width: "20%",
                  }}
                >
                  <img src={ier_logo} />
                </div>
                <div
                  style={{
                    width: "70%",
                  }}
                >
                  <span className="review-header-title-text">
                    INSTITUTION OF ENGINEERS RWANDA
                  </span>
                  <br />
                  <span className="review-sub-title">
                    Kimihurura - KG 666st Kigali-Rwanda <br />
                    P.o.Box 4386 Kigali Rwanda <br />
                    Telephone:
                    <span
                      style={{
                        fontWeight: "bold",
                        marginLeft: 2,
                      }}
                    >
                      (+250) 789 904 228
                    </span>
                    - Email:
                    <span
                      style={{
                        fontWeight: "bold",
                        marginLeft: 2,
                      }}
                    >
                      info@engineersrwanda.rw
                    </span>
                    - website:
                    <span
                      style={{
                        fontWeight: "bold",
                        marginLeft: 2,
                      }}
                    >
                      https://www.engineersrwanda.rw
                    </span>
                  </span>
                </div>
              </div>
              <div>
                <ReviewCard
                  title="Personal details"
                  path="/member/personal-details"
                  isMember={true}
                  state={applicationDetails}
                  // hasEdit={true}
                >
                  <div className="review-details-content-conatiner">
                    <div className="review-details-profile-container">
                      <div className="review-details-profile-icon">
                        {applicationDetails.portraitPhotoFile && (
                          <img
                            src={`data:image/${applicationDetails.portraitPhotoFile?.type};base64,${applicationDetails.portraitPhotoFile?.fileText}`}
                            style={{ width: "100%", height: "80%" }}
                          />
                        )}
                      </div>
                      <div>
                        <div>
                          <span>Title</span>
                          <p>{applicationDetails?.title || '-'}</p>
                        </div>
                        <div>
                          <span>First Name</span>
                          <p>{applicationDetails?.lastname || "-"}</p>
                        </div>
                        <div>
                          <span>Last Name</span>
                          <p>{applicationDetails?.firstname || "-"}</p>
                        </div>
                      </div>
                    </div>

                    <div className="review-details-gender-details">
                      <div>
                        <span>Gender</span>
                        <p>{applicationDetails?.gender}</p>
                      </div>
                      <div>
                        <span>Date of Birth</span>
                        <p>
                          {moment(applicationDetails?.dateOfBirth)?.format(
                            "MMMM Do YYYY"
                          )}
                        </p>
                      </div>
                      <div>
                        <span>Nationality</span>
                        <p>{applicationDetails?.countryFrom?.name}</p>
                      </div>
                      <div>
                        <span>Education Level</span>
                        <p>{applicationDetails?.awardType?.name}</p>
                      </div>
                    </div>

                    <div className="review-details-id-type">
                      <div>
                        <span>ID Type</span>
                        <p>{applicationDetails?.identificationDocumentType}</p>
                      </div>
                      <div>
                        <span>ID Number</span>
                        <p>
                          {applicationDetails?.identificationDocumentNumber}
                        </p>
                      </div>

                      <div className="review-details-id-card-container">
                        <span>ID Card Scan Attached </span>
                        <div className="d-flex">
                          <p>{applicationDetails.documentFile?.name}</p>
                          {applicationDetails.documentFile && (
                            <img
                              src={download_icon}
                              onClick={() =>
                                generateCertificate(
                                  applicationDetails.documentFile?.fileText
                                )
                              }
                              style={{
                                height: 40,
                                width: 40,
                                padding: 5,
                                marginLeft: 10,
                                cursor: "pointer",
                                marginTop: "-10px",
                              }}
                            />
                          )}
                        </div>
                      </div>
                      <div className="review-details-id-card-container">
                        <span>CV </span>
                        <div className="d-flex">
                          <p>{applicationDetails.cv?.name}</p>
                          {applicationDetails.cv && (
                            <img
                              src={download_icon}
                              onClick={() =>
                                generateCertificate(
                                  applicationDetails.cv?.fileText
                                )
                              }
                              style={{
                                height: 40,
                                width: 40,
                                padding: 5,
                                marginLeft: 10,
                                cursor: "pointer",
                                marginTop: "-10px",
                              }}
                            />
                          )}
                        </div>
                      </div>
                      {applicationDetails.technicalReportFile && (
                        <div className="review-details-id-card-container">
                          <span>Technical Report</span>
                          <div className="d-flex">
                            <p>
                              {applicationDetails.technicalReportFile?.name}
                            </p>
                            {applicationDetails.technicalReportFile && (
                              <img
                                src={download_icon}
                                onClick={() =>
                                  generateCertificate(
                                    applicationDetails.technicalReportFile
                                      ?.fileText
                                  )
                                }
                                style={{
                                  height: 40,
                                  width: 40,
                                  padding: 5,
                                  marginLeft: 10,
                                  cursor: "pointer",
                                  marginTop: "-10px",
                                }}
                              />
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </ReviewCard>

                <ReviewCard
                  title="Contact details"
                  path="/member/contact-details"
                  isMember={true}
                  // hasEdit={true}
                  state={applicationDetails}
                >
                  <div className="review-details-content-conatiner">
                    <div className="review-details-contact-container-first">
                      <div className="d-flex">
                        <div className="contancts-container">
                          <div>
                            <span>Main Phone Number</span>
                            <p>
                              {applicationDetails?.contactTelephoneNumber ||
                                "-"}
                            </p>
                          </div>
                        </div>
                        <div className="">
                          <div>
                            <span>Main Email Address</span>
                            <p>{applicationDetails?.contactEmail || "-"}</p>
                          </div>
                        </div>
                      </div>
                      <div className="seperator-contact"></div>
                      <div className="d-flex">
                        <div className="contancts-container">
                          <div>
                            <span>Next of Kin Phone Number</span>
                            <p>
                              {applicationDetails?.secondaryContactTelephoneNumber ||
                                "-"}
                            </p>
                          </div>
                        </div>
                        <div className="">
                          <div>
                            <span>Next of Kin Email Address</span>
                            <p>
                              {applicationDetails?.secondaryContactEmail || ""}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="review-details-contact-container-second">
                      <div className="">
                        <div style={{ wordWrap: "break-word" }}>
                          <span>Residence Address</span>
                          {applicationDetails.residenceType === "Local" ? (
                            <p>
                              {applicationDetails.province?.name},
                              {applicationDetails.district?.name},
                              {applicationDetails.sector?.name},
                              {applicationDetails.cell?.name},
                              {applicationDetails.village?.name},
                              {applicationDetails.streetOrHouseNumber}
                            </p>
                          ) : (
                            <p>
                              {applicationDetails.countryOfResidence?.name},{" "}
                              {applicationDetails.residenceAddress}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </ReviewCard>
                <ReviewCard
                  title="Educational details"
                  path="/member/educational-details"
                  isMember={true}
                  // hasEdit={true}
                  state={applicationDetails}
                >
                  <div className="review-details-content-conatiner">
                    <div
                      className="review-details-contact-container-first"
                      style={{ width: "100%" }}
                    >
                      {applicationDetails.educationDetails?.length > 0 && (
                        <div>
                          {applicationDetails.educationDetails.map((value) => {
                            return (
                              <div
                                className="d-flex dashboarder-grey-contanier mt-4"
                                style={{ justifyContent: "space-between" }}
                              >
                                <div>
                                  <div>
                                    <span>Institution Name</span>
                                    <p>{value.institutionName}</p>
                                  </div>
                                </div>
                                <div className="">
                                  <div>
                                    <span>Award Type</span>
                                    <p>{value.awardType?.name}</p>
                                  </div>
                                </div>
                                <div className="">
                                  <div>
                                    <span>Year of Award</span>
                                    <p>{value.yearOfAward}</p>
                                  </div>
                                </div>
                                <div className="mb-4">
                                  <span>Certified Award Attached</span>
                                  <div
                                    className="d-flex"
                                    style={{ alignItems: "center" }}
                                  >
                                    <p>{value.awardDocumentFile?.name}</p>
                                    {value.awardDocumentFile?.name && (
                                      <img
                                        src={download_icon}
                                        onClick={() =>
                                          generateCertificate(
                                            value?.awardDocumentFile?.fileText
                                          )
                                        }
                                        style={{
                                          height: 40,
                                          width: 40,
                                          padding: 5,
                                          marginLeft: 10,
                                          cursor: "pointer",
                                          marginTop: "-20px",
                                        }}
                                      />
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                          <div
                            className="seperator-contact"
                            style={{ width: "100%" }}
                          ></div>
                        </div>
                      )}
                    </div>
                  </div>
                </ReviewCard>
                <ReviewCard
                  title="CERTIFICATION DETAILS"
                  path="/member/certificate-details"
                  state={applicationDetails}
                  isMember={true}
                  // hasEdit={true}
                >
                  <div className="review-details-content-conatiner">
                    <div
                      className="review-details-contact-container-first"
                      style={{ width: "100%" }}
                    >
                      {applicationDetails.professionalCertificates?.length >
                        0 && (
                        <div>
                          {applicationDetails.professionalCertificates.map(
                            (value) => {
                              return (
                                <div
                                  className=" dashboarder-grey-contanier mt-4"
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <div
                                    className="d-flex"
                                    style={{ justifyContent: "space-between" }}
                                  >
                                    <div>
                                      <div>
                                        <span>Certificate Name</span>
                                        <p>{value.name}</p>
                                      </div>
                                    </div>
                                    <div className="">
                                      <div>
                                        <span>Provider</span>
                                        <p>{value.provider}</p>
                                      </div>
                                    </div>
                                    <div className="">
                                      <div>
                                        <span>Location</span>
                                        <p>{value.location}</p>
                                      </div>
                                    </div>
                                    <div className="">
                                      <div>
                                        <span>Start Date</span>
                                        <p>
                                          {moment(value.endDate).format(
                                            "MMMM Do YYYY"
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="d-flex mt-2">
                                    <div className="">
                                      <div>
                                        <span>End Date</span>
                                        <p>
                                          {moment(value.endDate).format(
                                            "MMMM Do YYYY"
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                    <div
                                      className="mb-4"
                                      style={{ marginLeft: 60 }}
                                    >
                                      <div>
                                        <span>Certified Award Attached</span>
                                        <div className="d-flex">
                                          <p>
                                            {
                                              value.certificateDocumentFile
                                                ?.name
                                            }
                                          </p>
                                          {value.certificateDocumentFile
                                            ?.name && (
                                            <img
                                              src={download_icon}
                                              onClick={() =>
                                                generateCertificate(
                                                  value?.certificateDocumentFile
                                                    ?.fileText
                                                )
                                              }
                                              style={{
                                                height: 40,
                                                width: 40,
                                                padding: 5,
                                                marginLeft: 10,
                                                cursor: "pointer",
                                                marginTop: "-10px",
                                              }}
                                            />
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          )}
                          <div
                            className="seperator-contact"
                            style={{ width: "100%" }}
                          ></div>
                        </div>
                      )}
                    </div>
                  </div>
                </ReviewCard>

                <ReviewCard
                  title="REFERENCES DETAILS"
                  path="/member/reference-details"
                  state={applicationDetails}
                  isMember={true}
                  // hasEdit={true}
                >
                  <div className="review-details-content-conatiner">
                    <div
                      className="review-details-contact-container-first"
                      style={{ width: "100%" }}
                    >
                      {applicationDetails.professionalReferences?.length >
                        0 && (
                        <div>
                          {applicationDetails.professionalReferences.map(
                            (value) => {
                              return (
                                <div
                                  className="d-flex dashboarder-grey-contanier mt-4"
                                  style={{ justifyContent: "space-between" }}
                                >
                                  <div>
                                    <div>
                                      <span>Full Names</span>
                                      <p>{value.name}</p>
                                    </div>
                                  </div>
                                  <div className="">
                                    <div>
                                      <span>Member Grade</span>
                                      <p>{value.memberGradeId}</p>
                                    </div>
                                  </div>
                                  <div className="">
                                    <div>
                                      <span>Member Number</span>
                                      <p>{value.ierMemberNumber}</p>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </div>
                      )}

                      <div
                        className="seperator-contact"
                        style={{ width: "100%" }}
                      ></div>
                      {applicationDetails.academicReferences?.length > 0 && (
                        <div>
                          {applicationDetails.academicReferences.map(
                            (value) => {
                              return (
                                <div
                                  className="d-flex dashboarder-grey-contanier mt-4"
                                  style={{ justifyContent: "space-between" }}
                                >
                                  <div>
                                    <div>
                                      <span>Full Names</span>
                                      <p>{value.name}</p>
                                    </div>
                                  </div>
                                  <div className="">
                                    <div>
                                      <span>Phone Number</span>
                                      <p>{value.telephoneNumber}</p>
                                    </div>
                                  </div>
                                  <div className="">
                                    <div>
                                      <span>Email Address</span>
                                      <p>{value.email}</p>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </ReviewCard>
              </div>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                paddingTop: "10%",
              }}
            >
              <LoadingSpinner color={"#1D834F"} />
            </div>
          )}
        </div>
      ) : (
        <FirmDetails
          applicationDetails={applicationDetails}
          application={apiResponse.application}
          actionLoader={actionLoader}
          generateCertificate={generateCertificate}
        />
      )}
    </>
  );
};

export default Membership;
